var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({
    active: true,
    callback: _vm.onWaypoint,
    options: _vm.intersectionOptions,
  }),expression:"{\n    active: true,\n    callback: onWaypoint,\n    options: intersectionOptions,\n  }"}],staticStyle:{"border":"0","position":"absolute","top":"0","left":"0","height":"100%","width":"100%"}},[_c('iframe',{ref:"video",staticStyle:{"border":"0","position":"absolute","top":"0","left":"0","height":"100%","width":"100%"},attrs:{"src":_vm.src,"loading":"lazy","allow":"accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }